export const UsuarioStatus = ['PENDENTE', 'EM_ANALISE', 'REPROVADO', 'APROVADO', 'REVOGADO', 'IGNORADO'];
